<div class="modal-backdrop" *ngIf="visible">
	<div class="custom-modal">
		<div class="modal-header">
			<h5 class="modal-title">Selecciona los filtros</h5>
		</div>

		<div class="modal-body">
			<div class="row mb-3">
				<div class="col-md-6">
					<label class="form-label">Fecha de inicio</label>
					<input
						type="date"
						class="form-control"
						[(ngModel)]="fechaInicio"
					/>
				</div>

				<div class="col-md-6">
					<label class="form-label">Fecha final</label>
					<input
						type="date"
						class="form-control"
						[(ngModel)]="fechaFinal"
					/>
				</div>
			</div>

			<div class="mb-3">
				<label class="form-label">Cliente</label>
				<select
					class="form-select custom-select"
					[(ngModel)]="selectedClientId"
					(ngModelChange)="onClienteChange()"
				>
					<option [ngValue]="null">Todos los clientes</option>

					<option *ngFor="let c of clientes" [ngValue]="c.id">
						{{ c.name }}
					</option>
				</select>
			</div>

			<div
				class="col-sm-9"
				*ngIf="selectedClientId && unidades.length > 0"
			>
				<label class="form-label">Unidad</label>
				<p-multiSelect
					[options]="unidades"
					[(ngModel)]="selectedUnitIds"
					display="chip"
					optionLabel="name"
					optionValue="id"
					placeholder="Selecciona..."
					[showClear]="true"
					class="w-100 multi-unidades"
				>
				</p-multiSelect>
			</div>
			<div class="mt-4">
				<label class="form-label d-block">
					Formato de evidencias
				</label>

				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="evidence_layout"
						id="evidence_no"
						[value]="'no'"
						[(ngModel)]="evidence_layout"
					/>

					<label class="form-check-label" for="evidence_no">
						Sin evidencias
					</label>
				</div>

				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="evidence_layout"
						id="evidence_compact"
						[value]="'compact'"
						[(ngModel)]="evidence_layout"
					/>

					<label class="form-check-label" for="evidence_compact">
						Solo 3 evidencias por tabla (Compacto)
					</label>
				</div>

				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="evidence_layout"
						id="evidence_full"
						[value]="'full'"
						[(ngModel)]="evidence_layout"
					/>

					<label class="form-check-label" for="evidence_full">
						Todas las evidencias posibles
					</label>
				</div>
			</div>
		</div>

		<div class="modal-footer">
			<button class="btn btn-secondary" (click)="cancelar()">
				Cancelar
			</button>
			<button class="btn btn-primary" (click)="aceptar()">Aceptar</button>
		</div>
	</div>
</div>
